<template>
    <div style="background: #f3f3f3">
        <CellGroup title="任务信息">
            <Cell title="任务名称" :value="detail.name"/>
            <Cell title="工单类型" :value="orderType"/>
            <Cell title="工单等级" :value="orderLevel"/>
        </CellGroup>
        <CellGroup title="设备信息">
            <Cell title="设备名称" :value="detail.deviceName"/>
            <Cell title="设备编号" :value="detail.deviceSn"/>
            <Cell title="所属区域" :value="detail.areaName"/>
            <Cell title="所属单位" :value="detail.unitName"/>
            <!--<Cell title="安装位置" :value="detail.device.installLocation"/>-->
        </CellGroup>
        <CellGroup title="指派信息">
            <Cell title="指派人" :value="detail.assignUser"/>
            <Cell title="被指派人" :value="userLists"/>
            <Cell title="指派时间" :value="detail.assignTime"/>
        </CellGroup>
        <div v-if="detail.handleUser!=null">
            <CellGroup title="处理信息">
                <Cell title="处理人" :value="detail.handleUserRealName"/>
                <Cell title="处理方式" :value="handleMethod"/>
                <Cell title="处理意见" :value="detail.handleRemark"/>
                <Cell title="处理时间" :value="detail.handleTime"/>
                <div
                        style="display:flex;justify-content : space-between;width:90%;margin:auto;margin-top:8px;"
                >
                    <UploadImage style="margin-left:-15px" :imageList="detail.handleImageList"/>
                </div>
            </CellGroup>
        </div>
        <div v-if="detail.confirmUser!=null">
            <div style="  margin: 15px 10px;">确认信息</div>
            <CellGroup>
                <Cell title="确认人" :value="detail.confirmUser"/>
                <Cell title="确认时间" :value="detail.confirmTime"/>
                <div style="height:50px;">&nbsp;</div>
            </CellGroup>
        </div>
        <pf code="ORDER_TASK_HANDLE">
            <Button v-if="detail.state=='UN_HANDLE'" type="info" @click="$router.push('/order/deal/' + orderId)" block
                    class="fixed-bottom-button">开始处理
            </Button>
        </pf>
        <div style="height:60px;"></div>
    </div>
</template>

<script>
    import {Button, Cell, CellGroup, Dialog, Popup} from 'vant';
    import UploadImage from "@/components/UploadImage";
    import * as DICT from "@/utils/dict"

    export default {
        components: {UploadImage, Button, Popup, CellGroup, Cell, Dialog},
        props: {},
        data() {
            return {
                orderId: this.$route.params.id,
                detail: {
                    handleImageList: []
                }
            }
        },
        computed: {
            userLists() {
                const userList = this.detail.executeUserList;
                return userList.map(item => item.realName).join(",")
            },
            handleMethod() {
                return DICT.getValue("ORDER_TSAK_HANDLE_METHOD", this.detail.handleMethod)
            },
            orderType() {
                return DICT.getValue("ORDER_TSAK_TYPE", this.detail.type)
            },
            orderLevel() {
                return DICT.getValue("ORDER_TSAK_LEVEL", this.detail.level)
            },
        },
        created() {
        },
        mounted() {
            this.getOrderDetail()
        },
        methods: {
            getOrderDetail() {
                this.$http.tokiot.order.task.get({id: this.orderId})
                    .then(res => {
                        if (res) {
                            this.detail = res;
                        }
                    })
            }
        },
        watch: {}
    }
</script>

<style lang="less" scoped>
    .fixed-bottom-button {
        position: fixed;
        margin-left: 8px;
        bottom: 8px;
        width: calc(100% - 16px);
    }

</style>